<!--
© Copyright 2015-2026 Personalized Privacy Assistant Project, Carnegie Mellon University - All Rights Reserved - US Patent 11,768,949, US Patent 10,956,586, US Patent 12,235,973, and additional USPTO and EPO patents pending.
This code is proprietary and confidential. For any questions about this code, including licensing, please contact Prof. Norman Sadeh (sadeh@cs.cmu.edu).
-->
<template>
  <div id="resourcemap" style="height: 450px"></div>
</template>

<script>
    export default {
      props: {
        route: String,
        resource: Object, //single resource
        resources: Array, //multiple resources
        activeResourceId: Number,
        existingData: [Object, Array],
      },
      data() {
        return {
          map: false,
          areaOfAuthority: false,
          resourceMarker: false,
          currentLat: 0,
          currentLng: 0,
          currentResource: 0,
          componentMounted: false,
        }
      },
      watch: {
        //watch for activeResourceId changes
        activeResourceId: function () {
          this.changeActiveResource(this.activeResourceId);
        }
      },
      mounted: function () {
        this.$nextTick(function () {  //don't run until the entire view has been rendered
          //init the current resource
          if(this.route == 'show') {
            this.currentResource = (typeof this.resource != 'undefined') ? this.resource : false;
          } else if(this.route == 'index') {
            this.currentResource = (typeof this.resources[0] != 'undefined') ? this.resources[0] : false;
          }

          //init current Lat Lng
          if(this.currentResource) {
            this.currentLat = this.currentResource.latitude;
            this.currentLng = this.currentResource.longitude;
          }

          //init the map
          this.map = window.L.map('resourcemap').setView([39.8, -98.6], 4); //default to United States view
          //this.map.dragging.disable(); //disable panning

          //add the content
          //L.tileLayer('/map/tile/{s}/{id}/{z}/{x}/{y}', {  //for use when proxying the tile requests

          /* DEPRECATED VERSION L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', {
      			attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/" target="_blank">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/" target="_blank">CC-BY-SA</a>',
      			maxZoom: 18,
            minZoom: 3,
      			id: 'mapbox.streets',
      			accessToken: 'pk.eyJ1IjoiamRvbm5lbGwiLCJhIjoiY2ptZHN1azhqMHR2MDNxbnF2eWloOTRoeSJ9.RlFLdSY8e_anTpJNUJhIkA',
      		}).addTo(this.map); */

          L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
            attribution: '© <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> <strong><a href="https://www.mapbox.com/map-feedback/" target="_blank">Improve this map</a></strong>',
            tileSize: 512,
            maxZoom: 18,
            minZoom: 3,
            zoomOffset: -1,
            id: 'jdonnell/ckg9vp1o403lx1as8i81og3ir',
            accessToken: 'pk.eyJ1IjoiamRvbm5lbGwiLCJhIjoiY2ptZHN1azhqMHR2MDNxbnF2eWloOTRoeSJ9.RlFLdSY8e_anTpJNUJhIkA'
          }).addTo(this.map);

          window.L.control.scale().addTo(this.map);

          //update map elements for the resource
          this.updateResourceOnMap();

          this.componentMounted = true;
        })
      },
      methods: {
        decodeStoredEntities: function(value) {
          if (typeof value !== 'string' || value.indexOf('&') === -1) {
            return value;
          }

          var decoded = value;
          for (var i = 0; i < 5; i++) {
            var next = decoded
              .replace(/&amp;/g, '&')
              .replace(/&#038;/g, '&')
              .replace(/&#039;/g, "'")
              .replace(/&#39;/g, "'")
              .replace(/&#x27;/gi, "'")
              .replace(/&apos;/g, "'")
              .replace(/&quot;/g, '"')
              .replace(/&#34;/g, '"')
              .replace(/&#x22;/gi, '"');

            if (next === decoded) {
              break;
            }
            decoded = next;
          }

          return decoded;
        },
        escapeHtml: function(value) {
          if (typeof value !== 'string') {
            return value;
          }

          return value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
        },
        //called when the user has changed the active resource (e.g. clicked a resource on the page)
        changeActiveResource: function($id) {
          if(typeof this.resources[$id] != 'undefined') {
            this.currentResource = this.resources[$id];
            this.currentLat = this.currentResource.latitude;
            this.currentLng = this.currentResource.longitude;
            this.updateResourceOnMap();
          }
        },
        //update map elements based on the currently active resource
        updateResourceOnMap: function() {
          //update map setView
          if(this.map && this.currentResource) {  //if there is a currently selected resource and a map
            this.map.setView([this.currentLat, this.currentLng], 16);

            if(this.areaOfAuthority) {
              this.map.removeLayer(this.areaOfAuthority)  //remove the current area of authority
            }
            //draw a circle for the Resource's area of coverage
            this.areaOfAuthority = L.circle([this.currentLat, this.currentLng], {
        			color: 'orange',
        			fillColor: '#ffa200',
        			fillOpacity: 0.1,
        			radius: this.currentResource.radius
        		}).addTo(this.map);

            if(this.resourceMarker) {
              this.map.removeLayer(this.resourceMarker) //remove the current marker
            }

            //add marker for the resource
            this.resourceMarker = L.marker([this.currentLat, this.currentLng]).addTo(this.map);

            //create a popup and bind it to the marker
            if(this.route == 'index') {
              var popupURL = '/resource/' + this.currentResource.id;
              var popupButtonText = 'View Resource';
            }
            else if(this.existingData.isOwner) {
              var popupURL = '/resource/' + this.currentResource.id + '/edit/';
              var popupButtonText = 'Edit Resource';
            }

            var decodedName = this.decodeStoredEntities(this.currentResource.name || '');
            var decodedDescription = this.decodeStoredEntities(this.currentResource.description || '');
            var resourcePopup = '<h4>' + this.escapeHtml(decodedName) + '</h4><p class="lead">' + this.escapeHtml(decodedDescription) + '</p>';
            resourcePopup += (this.route == 'index' || this.existingData.isOwner) ? '<center><a type="button" class="btn btn-resource btn-sm" href="' + popupURL + '">' + popupButtonText + '</a></center>' : '';
            this.resourceMarker.bindPopup(resourcePopup);

            //fire a click event on the marker to display the popup immediately
            this.resourceMarker.fireEvent('click');


            //scroll page back to map
            if(this.route == 'index' && this.componentMounted) { //only run for index view and don't run on initial load of the page/map
              $('html, body').animate({
                  scrollTop: ($('#resourcemap').first().offset().top)
                },500);
            }
          } else {
            this.areaOfAuthority = false;
            this.resourceMarker = false;
          }
        },  //end function
      },    //end methods
    }
</script>
